(() => {
  const d = document;
  const body = d.body;
  const menu = d.querySelector('[data-site-menu]');
  const openBtn = d.querySelector('[data-menu-open]');
  let lastFocus;
  const focusable = () => menu ? [...menu.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter(el => !el.disabled && el.offsetParent !== null) : [];
  const openMenu = () => {
    if (!menu) return;
    lastFocus = d.activeElement;
    menu.hidden = false;
    requestAnimationFrame(() => menu.classList.add('is-open'));
    body.classList.add('menu-is-open');
    openBtn?.setAttribute('aria-expanded','true');
    setTimeout(() => focusable()[0]?.focus(), 80);
  };
  const closeMenu = () => {
    if (!menu) return;
    menu.classList.remove('is-open');
    body.classList.remove('menu-is-open');
    openBtn?.setAttribute('aria-expanded','false');
    setTimeout(() => { menu.hidden = true; lastFocus?.focus(); }, 350);
  };
  openBtn?.addEventListener('click', openMenu);
  d.querySelectorAll('[data-menu-close]').forEach(el => el.addEventListener('click', closeMenu));
  d.addEventListener('keydown', e => {
    if (e.key === 'Escape' && menu?.classList.contains('is-open')) closeMenu();
    if (e.key === 'Tab' && menu?.classList.contains('is-open')) {
      const f = focusable(); if (!f.length) return;
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length-1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length-1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  const header = d.querySelector('[data-site-header]');
  const setHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 30);
  setHeader(); addEventListener('scroll', setHeader, {passive:true});

  d.querySelectorAll('[data-dish-tabs]').forEach(group => {
    const tabs = [...group.querySelectorAll('[data-dish-tab]')];
    const panels = [...group.querySelectorAll('[data-dish-panel]')];
    const activate = index => {
      tabs.forEach((tab,i) => { const on=i===index; tab.classList.toggle('is-active',on); tab.setAttribute('aria-selected',String(on)); });
      panels.forEach((panel,i) => { const on=i===index; panel.classList.toggle('is-active',on); panel.hidden=!on; });
    };
    tabs.forEach((tab,i) => {
      tab.addEventListener('click',() => activate(i));
      tab.addEventListener('mouseenter',() => { if (matchMedia('(hover:hover)').matches) activate(i); });
      tab.addEventListener('keydown',e => {
        if (!['ArrowDown','ArrowUp','ArrowRight','ArrowLeft','Home','End'].includes(e.key)) return;
        e.preventDefault(); let n=i;
        if (['ArrowDown','ArrowRight'].includes(e.key)) n=(i+1)%tabs.length;
        if (['ArrowUp','ArrowLeft'].includes(e.key)) n=(i-1+tabs.length)%tabs.length;
        if (e.key==='Home') n=0; if (e.key==='End') n=tabs.length-1;
        tabs[n].focus(); activate(n);
      });
    });
  });

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && body && getComputedStyle(body).getPropertyValue('--enable-reveal').trim() !== '0') {
    const items = d.querySelectorAll('.reveal-section,.reveal-item');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), {threshold:.12, rootMargin:'0px 0px -5%'});
    items.forEach(el => observer.observe(el));
  } else d.querySelectorAll('.reveal-section,.reveal-item').forEach(el => el.classList.add('is-visible'));
})();
